<template>
  <modal
    :modal-id="modalId"
    :title="modalTitle"
    :preloader="preloader"
    modal-size="large"
    @submit="submit"
    @close-modal="closeModal"
  >
    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="selectedUrl ? `${postUrl}/${inputs.id}` : postUrl"
      >
      <div class="row">
        <div class="col-md-6">
          <label for="certificate_id">
            Certificate ID
          </label>
          <app-input
              id="certificate_id"
              type="text"
              v-model="inputs.certificate_id"
              :required="true"
          />
        </div>

        <div class="col-md-6">
          <label for="certificate_name">
            Certificate Name
          </label>
          <app-input
              id="certificate_name"
              type="text"
              v-model="inputs.certificate_name"
              :required="true"
          />
        </div>

        <div class="col-md-6">
          <label for="date_achieved">
            Date Achieved
          </label>
          <app-input
              id="date_achieved"
              type="date"
              v-model="inputs.date_achieved"
              :required="true"
          />
        </div>

        <div class="col-md-6">
          <label for="expiry_date">
            Expiry Date
          </label>
          <app-input
              id="expiry_date"
              type="date"
              v-model="inputs.expiry_date"
              :required="true"
          />
        </div>
        <div class="col-md-6">
          <label for="certification_body">
            Certification Body
          </label>
          <app-input
              id="certification_body"
              type="text"
              v-model="inputs.certification_body"
              :required="true"
          />
        </div>
        <div class="col-md-6">
          <label for="certificate_file">
            Certificate File
          </label>
          <app-input
              id="certificate_file"
              type="file"
              v-model="inputs.certificate_file"
              :required="true"
          />
          <p v-if="fileView" class="mt-4">Last Upload: <span><a :href="fileUrl" download="download">View Insurance File</a></span></p>

        </div>

        <div class="col-md-6">
          <label for="status">
            Status
          </label>
          <app-input
              id="status"
              type="text"
              v-model="inputs.status"
              :required="true"
          />
        </div>

      </div>
      </form>
    </template>
  </modal>
</template>

<script>
import { FormMixin } from "../../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../../Mixins/ModalMixin";
import * as actions from "../../../../../Config/ApiUrl";
import { axiosPost} from "../../../../../../app/Helpers/AxiosHelper";
import AppLibrary from "../../../../../Helpers/AppLibrary";


export default {
  name: "AccreditationAddModal",
  extends: AppLibrary,
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    companyId: Number,
  },
  data() {
    return {
      fileView: false,
      postUrl:actions.COMPANY_ACCREDITATION_STORE,
      preloader: false,
      inputs: {
        company_id: this.companyId,
      },
      statusLists: [
        { id: "no", value: "No" },
        { id: "yes", value: "Yes" },
      ],
      modalId: "accreditation-add-edit-modal",
      modalTitle: this.$t("add"),
    };
  },
  created() {
    if (this.selectedUrl) {
      this.modalTitle = this.$t("edit");
    }
  },
  methods: {
    submit() {
      this.inputs.expiry_date = this.getDateFormatForBackend(this.inputs.expiry_date)
      this.inputs.date_achieved = this.getDateFormatForBackend(this.inputs.date_achieved)

      let formData = new FormData;
      for (const [key, value] of Object.entries(this.inputs)) {
        formData.append(key, value);
      }
      if (this.modalTitle == "Edit") {
        this.preloader = true;
        axiosPost(actions.COMPANY_ACCREDITATION_UPDATE, formData)
          .then((res) => {
            
            this.$toastr.s(res.data.message);
          })
          .catch((error) => {
            
            this.$toastr.e(error);
          })
          .finally(() => {
            this.preloader = false;
            $("#accreditation-add-edit-modal").modal("hide");
            this.$hub.$emit("reload-" + this.tableId);
          });
      } else {
      this.save(formData);
      }
    },
    afterSuccess(response) {
      this.$toastr.s(response.data.message);
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      // if (response.data.phone) this.phone = response.data.phone;
      this.inputs = response.data;
      if(response.data.certificate_file) {
        this.fileUrl = response.data.file;
        this.fileView =true;
      }
      this.preloader = false;
    },
  },

  mounted() {
    // $(function () {
    //   $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
    // });
  },
};
</script>
<style>
.custom-file-label{
  height: 36px !important;
}
</style>
